import type { LanguageCode } from "config/languages";
import { getParentLanguage } from "utils/localeUtils";
import { LOGOTYPES } from "./consts";

export const getLocalizedLogotypes = (language: LanguageCode) =>
  LOGOTYPES[language] || LOGOTYPES[getParentLanguage(language)] || LOGOTYPES.en;
